// extracted by mini-css-extract-plugin
export default {"wrapper":"IPrp66fEK30i5Zfo67snUw==","icon":"JuObUr0FtRQ-QqhloAXsQg==","container":"elWgiiIg73ptC0OHrqdrPg=="};